export const esportesCBHB = [
    { label: "INDOOR", value: 1 },
    { label: "BEACH", value: 2 },
    { label: "CBHB", value: 3 },
    { label: "GERAL", value: 4 }
]